/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cx from 'classnames';

import Layout from '../../components/Layout/Layout';
import LayoutBlog from '../../components/Layout/LayoutBlog';
import Seo from '../../components/Seo';
import WidgetButtonList from '../../components/WidgetList/WidgetButtonList';
import CardResource from '../../components/CardResource/CardResource';
import SmallHero from '../../components/SmallHero/small-hero';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

import heroBg from '../../images/header-educational-content.png';

export const pageQuery = graphql`
  query ResourcePageQuery {
    allWpResourcesCategory {
      nodes {
        id
        uri
        name
      }
    }
    allWpResource(sort: { fields: [date], order: DESC }) {
      nodes {
        id
        uri
        title
        resourcesCategories {
          nodes {
            id
            slug
            name
          }
        }
        resourcesFields {
          externalLink
        }
      }
    }
  }
`;

const breadcrumbs = [
  {
    id: 'resources',
    name: 'Resources',
  },
  {
    id: 'educationalcontent',
    name: 'Educational Content',
  },
];

const EducationalContentPage = ({ data, location: { pathname } }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showPosts, setShowPosts] = useState([]);

  const categories = data.allWpResourcesCategory.nodes;
  const posts = data.allWpResource.nodes;

  const handleClick = (item) => {
    setSelectedCategories((prev) => {
      const exists = prev.some((id) => id === item.id);

      if (exists) {
        return prev.filter((id) => id !== item.id);
      }

      return [...prev, item.id];
    });
  };

  useEffect(() => {
    if (!selectedCategories.length) {
      setShowPosts(posts.map((p) => p.id));
      return;
    }

    const ids = posts.reduce((acc, post) => {
      const toShow = post.resourcesCategories.nodes.some((postCategory) =>
        selectedCategories.some(
          (selectedCategory) => postCategory.id === selectedCategory,
        ),
      );

      return toShow ? [post.id, ...acc] : acc;
    }, []);

    setShowPosts(ids);
  }, [posts, selectedCategories]);

  return (
    <Layout>
      <Seo
        title="Educational Content | Integra Connect Resources"
        description="Integra Connect's Educational Content provides valuable resources for healthcare providers and organizations to stay informed and up-to-date on the latest trends and best practices in healthcare. Browse our selection of webinars, white papers, and more."
        canonical={pathname}
      />

      <SmallHero title="Educational Content" background={heroBg}>
        <Breadcrumb items={breadcrumbs} />
      </SmallHero>

      <section className="c-section c-section--radius  c-section--negative_mt bg-white">
        <LayoutBlog
          sidebar={
            <WidgetButtonList
              items={categories}
              onClick={handleClick}
              activeIds={selectedCategories}
            />
          }
        >
          <Row>
            {posts.map((post) => {
              const [category] = post.resourcesCategories.nodes;

              return (
                <Col
                  key={post.id}
                  md={4}
                  className={cx('mb-4 card-filter-off', {
                    'card-filter-on': showPosts.includes(post.id),
                  })}
                >
                  <CardResource
                    slug={category?.slug}
                    title={category?.name}
                    text={post.title}
                    link={post.resourcesFields?.externalLink || post.uri}
                  />
                </Col>
              );
            })}
          </Row>
        </LayoutBlog>
      </section>
    </Layout>
  );
};

export default EducationalContentPage;
